var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.004,
    height: 80.219,
    viewBox: "0 0 54.004 80.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20092",
    "data-name": "Group 20092",
    transform: "translate(-32.946 -19.88)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44480",
    "data-name": "Path 44480",
    d: "M43.155,40.638c.035,2.009.174,4.008.3,6.012",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44481",
    "data-name": "Path 44481",
    d: "M35,51.22c1.416-.038,2.821-.157,4.233-.236",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44482",
    "data-name": "Path 44482",
    d: "M47.737,51.19c1.236-.233,2.468-.469,3.7-.721",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44483",
    "data-name": "Path 44483",
    d: "M44.173,55.393a31.923,31.923,0,0,0-.058,5.973",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44484",
    "data-name": "Path 44484",
    d: "M55.5,87.525c1.085-.1,2.22-.111,3.293-.314",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44485",
    "data-name": "Path 44485",
    d: "M63.3,76.044c-.144,2,.1,3.986.149,5.985",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44486",
    "data-name": "Path 44486",
    d: "M63.526,91.621a34.708,34.708,0,0,0,.2,6.147",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44487",
    "data-name": "Path 44487",
    d: "M69.427,86.856c1.529-.063,3-.2,4.509-.408",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44488",
    "data-name": "Path 44488",
    d: "M73.182,22c.127,2.044.311,4.078.362,6.126",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44489",
    "data-name": "Path 44489",
    d: "M64.161,34.711c1.585-.235,3.19-.312,4.769-.539",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44490",
    "data-name": "Path 44490",
    d: "M74.22,38.438c.36,2.583.425,5.517,1.145,8.036",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44491",
    "data-name": "Path 44491",
    d: "M80.1,33.048c1.562-.177,3.125-.206,4.688-.342",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.156d86a64802e8bbcf0406add546925e.svg";
export { ForwardRef as ReactComponent };